// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1989":"586896e2","3258":"51a3a7fb","7545":"6c06e2cb"}[chunkId] + ".chunk.css";
};